'use strict';

/* !
 * jQuery findimage v1.0.0
 * Copyright 2016, Connecty Inc.
 * use: Vue.js v1.0.28
 * use: wookmark.js
 */
(function ($, SANGETSU) {
	var v = 'is-visible';
	var n = 'is-novisible';
	var l = 'is-loading';
	var timer = false;
	var thisId = void 0;
	if (SANGETSU.va.pathname.indexOf('detail') >= 0) {
		thisId = SANGETSU.va.pathname.split('/')[3].replace(/\.html/g, ''); // URLからID取得
	}
	var searchProd = [];
	if (location.search && location.search.indexOf('product=') !== -1) {
		var searchArr = location.search.split('&');
		for (var i = 0; i < searchArr.length; i++) {
			if (searchArr[i].indexOf('product') !== -1) {
				searchProd.push(searchArr[i].split('=')[1]);
			}
		}
	}

	// CSV取得
	var csvToArray = function csvToArray(strData) {
		var strDelimiter = ',';
		var objPattern = new RegExp('(\\' + strDelimiter + '|\\r?\\n|\\r|^)' + '(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|' + '([^\"\\' + strDelimiter + '\\r\\n]*))', 'gi');
		var arrData = [[]];
		var arrMatches = null;
		var strMatchedValue = void 0;
		while ((arrMatches = objPattern.exec(strData)) !== null) {
			var strMatchedDelimiter = arrMatches[1];
			if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
				arrData.push([]);
			}
			if (arrMatches[2]) {
				strMatchedValue = arrMatches[2].replace(new RegExp('\"\"', 'g'), '\"');
			} else {
				strMatchedValue = arrMatches[3];
			}
			arrData[arrData.length - 1].push(strMatchedValue);
		}
		// console.dir(arrData);

		var items = arrData[0];
		var jsonArr = [];
		for (var _i = 1; _i < arrData.length - 1; _i++) {
			if (arrData[_i].length) {
				var a_line = {};
				var csvArrayD = arrData[_i];
				for (var j = 0; j < items.length; j++) {
					a_line[items[j]] = csvArrayD[j];
				}
				jsonArr.push(a_line);
			}
		}
		return jsonArr;
	};

	// ＜一覧＞画像事前読み込み
	var promiseThumbnailImageLoad = function promiseThumbnailImageLoad() {
		var d = $.Deferred();
		var $img = $('.findimages-list').find('img');
		var imgLen = $img.length;
		var array = [];

		var sum = function sum(_$this) {
			array.push(_$this);
			if (imgLen === array.length) {
				d.resolve();
			}
		};
		var loaded = function loaded(_$this) {
			if (_$this.complete) {
				sum(_$this);
			} else {
				var img = new Image();
				img.src = _$this[0].src;
				img.addEventListener('load', function () {
					return sum(_$this);
				});
			}
		};

		if (imgLen === 0) {
			d.resolve();
		} else {
			for (var _i2 = 0; _i2 < imgLen; _i2++) {
				loaded($img.eq(_i2));
			}
		}

		return d.promise();
	};

	// ＜詳細＞画像事前読み込み
	var promiseDetailImageLoad = function promiseDetailImageLoad() {
		var d = $.Deferred();
		$('.findimages-detail-img').find('img').on('load', function () {
			return d.resolve();
		});
		return d.promise();
	};

	// ＜一覧＞Wookmark処理
	var exeWookmark = function exeWookmark() {
		var wookmark1 = new Wookmark('.findimages-list', {
			offset: 10
		});
		$('#vue-item').find('img').width('100%').height('auto');

		setTimeout(function () {
			wookmark1.layout(true);
		});
	};

	// 読み込み完了時の処理
	var endLoad = function endLoad() {
		if (SANGETSU.va.pathname.indexOf('detail') === -1) {
			$.when(promiseThumbnailImageLoad()).done(function () {
				exeWookmark();
				$('.mod-loader').removeClass(l);
				$('.findimages-main').addClass(v);
				$('.findimages-amount').addClass(v);
				$('img').bind('contextmenu', function () {
					return false;
				});
			});
		} else {
			$.when(promiseDetailImageLoad()).done(function () {
				$('.mod-loader').removeClass(l);

				// 配列にあるIDのコーディネート画像は右クリック禁止
				var excID = ['info9045'];
				if (excID.indexOf(thisId) >= 0) {
					$('img').bind('contextmenu', function () {
						return false;
					});
				}
				$('.findimages_detail').addClass(v);
			});
		}
	};

	// -- ▲ functions ▲ -------------------------------------------------------------------
	// ------------------------------------------------------------------------------------

	var csvData = new XMLHttpRequest();
	csvData.open('get', '/findimages/item.csv', true);
	csvData.send(null);
	csvData.onload = function () {
		var json = csvToArray(csvData.responseText);
		// console.dir(json);

		var vue = new Vue({
			el: '#vue-item',
			data: {
				jsonData: json,
				checkedStyle: [],
				checkedPlace: [],
				checkedProduct: searchProd ? searchProd : [],
				num: 0,
				page: 0,
				dispItemSize: 24
			},
			created: function created() {
				this.$watch('checkedStyle', function () {
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					this.page = 0;
					this.$nextTick(function () {
						$('.findimages-main').removeClass(n);
						endLoad();
					});
				});
				this.$watch('checkedPlace', function () {
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					this.page = 0;
					this.$nextTick(function () {
						$('.findimages-main').removeClass(n);
						endLoad();
					});
				});
				this.$watch('checkedProduct', function () {
					console.log(this.checkedProduct);
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					this.page = 0;
					this.$nextTick(function () {
						$('.findimages-main').removeClass(n);
						endLoad();
					});
				});
				this.$watch('page', function () {
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					this.$nextTick(function () {
						$('.findimages-main').removeClass(n);
						endLoad();
					});
				});
			},
			methods: {
				detailID: function detailID(item) {
					if (item.id === thisId) {
						return item;
					}
					return false;
				},
				showPrev: function showPrev() {
					if (this.isStartPage) return;
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					$(window).scrollTop(0);
					this.page--;
					$('.findimages-main').removeClass(n);
				},
				showNext: function showNext() {
					if (this.isEndPage) return;
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					$(window).scrollTop(0);
					this.page++;
					$('.findimages-main').removeClass(n);
				},
				showPage: function showPage(index) {
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					$(window).scrollTop(0);
					this.page = index;
					$('.findimages-main').removeClass(n);
				},
				setURL: function setURL(_id) {
					return '/findimages/detail/' + _id + '.html';
				},
				setImg: function setImg(_id) {
					return '/images/findimages/' + _id + '.jpg';
				},
				setThumb: function setThumb(_id) {
					return '/images/findimages/' + _id + '_s.jpg';
				},
				setStyle: function setStyle(_style) {
					switch (_style) {
						case 'simple_modern':
							return 'シンプルモダン';
						case 'nordic':
							return 'ノルディック＆カジュアル';
						case 'chic_modern':
							return 'シックモダン';
						case 'traditional':
							return 'トラディショナル';
						case 'japanesque':
							return '和モダン';
						case 'feminine_elegans':
							return 'フェミニン＆エレガンス';
						case 'natural_comfort':
							return 'ナチュラルコンフォート';
						case 'industrial':
							return 'インダストリアル';
						default:
							return false;
					}
				},
				setPlace: function setPlace(_place) {
					switch (_place) {
						case 'entrance':
							return '玄関';
						case 'bedroom':
							return '寝室';
						case 'living_dining':
							return 'LDK';
						case 'kidsroom':
							return '子ども部屋';
						case 'japanese_style':
							return '和室';
						case 'washroom':
							return '洗面・トイレ';
						case 'western_style':
							return '洋室・ワークスペース';
						default:
							return false;
					}
				},
				setCategory: function setCategory(_cat) {
					switch (_cat) {
						case 'wall':
							return '壁紙';
						case 'reatec':
							return 'リアテック';
						case 'film':
							return 'ガラスフィルム';
						case 'carpet':
							return 'カーペット';
						case 'carpettile':
							return 'カーペットタイル';
						case 'floortile':
							return 'フロアタイル';
						case 'floor':
							return 'クッションフロア';
						case 'curtain':
							return 'カーテン';
						case 'rollscreen':
							return 'ロールスクリーン';
						case 'pleatedscreen':
							return 'プリーツスクリーン';
						case 'verticalblinds':
							return 'バーチカルブラインド';
						case 'woodblinds':
							return 'ウッドブラインド';
						case 'kyogisudare':
							return '経木すだれ';
						case 'chair':
							return '椅子生地';
						case 'other':
							return 'その他';
						default:
							return false;
					}
				},
				setProd: function setProd(_prod) {
					var prodList = _prod.split('\n');
					var prodListHTML = '';
					for (var _i3 = 0; _i3 < prodList.length; _i3++) {
						var id = prodList[_i3].split('|')[0];
						var cat = prodList[_i3].split('|')[1];
						var url = prodList[_i3].split('|')[2];
						if (url) {
							if (url === 'N') {
								prodListHTML += '<li><span><span>' + id + '</span>' + ('<span class="findimages-detail-category color-bg_' + cat + '">' + this.setCategory(cat) + '</span></span></li>');
							} else if (url.indexOf('http') === 0) {
								prodListHTML += '<li><a href="' + url + '"><span>' + id + '</span>' + ('<span class="findimages-detail-category color-bg_' + cat + '">' + this.setCategory(cat) + '</span></a></li>');
							} else {
								prodListHTML += '<li><a href="/product/detail/' + url + '/"><span>' + id + '</span>' + ('<span class="findimages-detail-category color-bg_' + cat + '">' + this.setCategory(cat) + '</span></a></li>');
							}
						} else {
							prodListHTML += '<li><a href="/product/detail/' + id + '/"><span>' + id + '</span>' + ('<span class="findimages-detail-category color-bg_' + cat + '">' + this.setCategory(cat) + '</span></a></li>');
						}
					}
					return prodListHTML;
				}
			},
			computed: {
				filterItems: function filterItems() {
					var items = this.jsonData;

					// style
					if (this.checkedStyle.length) {
						var itemsStyle = [];
						for (var _i4 = 0; _i4 < items.length; _i4++) {
							if (this.checkedStyle.indexOf(items[_i4].style) !== -1) {
								itemsStyle.push(items[_i4]);
							}
						}
						items = itemsStyle;
					}
					// place
					if (this.checkedPlace.length) {
						var itemsPlace = [];
						for (var _i5 = 0; _i5 < items.length; _i5++) {
							if (this.checkedPlace.indexOf(items[_i5].place) !== -1) {
								itemsPlace.push(items[_i5]);
							}
						}
						items = itemsPlace;
					}
					// アイテム（OR検索）
					if (this.checkedProduct.length) {
						var itemsProduct = [];
						for (var _i6 = 0; _i6 < items.length; _i6++) {
							var pushFlg = false;
							for (var j = 0; j < this.checkedProduct.length; j++) {
								var thisEleProdList = items[_i6].product.split('\n');
								for (var k = 0; k < thisEleProdList.length; k++) {
									var thisEleCat = thisEleProdList[k].split('|')[1];
									if (thisEleCat === this.checkedProduct[j] && !pushFlg) {
										itemsProduct.push(items[_i6]);
										pushFlg = true;
									}
								}
							}
						}
						items = itemsProduct;
					}

					// count
					this.num = items.length;
					// paging
					var startPage = this.page * this.dispItemSize;
					items = items.slice(startPage, startPage + this.dispItemSize);

					return items;
				},
				filterDetailItem: function filterDetailItem() {
					var items = [];
					for (var _i7 = 0; _i7 < this.jsonData.length; _i7++) {
						if (thisId === this.jsonData[_i7].id) {
							items.push(this.jsonData[_i7]);break;
						}
					}
					if (items.length) {
						return items;
					} else {
						// 存在しないIDでアクセスされた場合は404へリダイレクト
						location.href = '/404.html';
						return false;
					}
				},
				isStartPage: function isStartPage() {
					return this.page === 0;
				},
				isEndPage: function isEndPage() {
					return (this.page + 1) * this.dispItemSize >= this.num;
				},
				pageCount: function pageCount() {
					return Math.ceil(this.num / this.dispItemSize);
				}
			}
		});

		// 初回読み込み
		vue.$nextTick(function () {
			$('.findimages-main').removeClass(n);
			endLoad();
		});

		if (SANGETSU.va.pathname.indexOf('detail') === -1) {
			$('.mod-searchForm-hide').on('click', function () {
				$('.mod-searchForm-hide-switch').toggleClass('is-active');
				$('.mod-searchForm-detail').stop().slideToggle('fast');
			});

			// 一覧：画像読込後に並び調整
			endLoad();

			// 一覧：ウィンドウサイズが変わったら並び調整
			$(window).resize(function () {
				if (timer !== false) {
					clearTimeout(timer);
				}
				timer = setTimeout(function () {
					exeWookmark();
				}, '200');
			});
		}
	};
})(window.jQuery, window.SANGETSU);